import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { mileage } from "@signals"


export default function AppCommonFiltersMileageSelect({ ...props }) {
	return <SelectSeeker
		label="Mileage"
		value={mileage.value}
		isClearable
		onChange={e => mileage.value = e.target.value}
		placeholder="No restrictions"
		options={[
			{ label: 'Option 1', value: 'EUR' },
			{ label: 'Option 2', value: 'GBP' }
		]}
		{...props}
	/>
}